/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Training } from '../../models/training';
import { TrainingCriteria } from '../../models/training-criteria';

export interface ApiMasterTrainingGetByCriteriaPost$Params {
      body?: TrainingCriteria
}

export function apiMasterTrainingGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterTrainingGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Training>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTrainingGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Training>>;
    })
  );
}

apiMasterTrainingGetByCriteriaPost.PATH = '/api/Master/Training/GetByCriteria';
